module.exports = __webpack_public_path__ + "img/estoque-armazenado.6e41a292.svg";